<template>
  <div class="cases">
    <el-button type="primary" @click="openDialog()">新增案例</el-button>

    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="caseId" label="序号" width="180"></el-table-column>
      <el-table-column prop="caseTitle" label="案例标题" width="180"></el-table-column>
      <el-table-column prop="imgId" label="图片">
        <template slot-scope="scope">
          <img style="width:100%" :src="imgurl + scope.row.imgId" alt />
        </template>
      </el-table-column>
      <el-table-column prop="caseContent" label="案例简介"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></el-button>
          <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="案例编辑" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <el-form-item label="案例标题" :label-width="formLabelWidth">
          <el-input v-model="formData.caseTitle" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="案例图片" :label-width="formLabelWidth">
          <!-- :before-upload="beforeAvatarUpload" -->
          <el-upload class="avatar-uploader" :action=imgurl :show-file-list="false" :on-success="handleSuccess">
            <img v-if="formData.imgId != 0" :src="imgurl + formData.imgId" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="案例简介" :label-width="formLabelWidth">
          <el-input v-model="formData.caseContent" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="案例内容" :label-width="formLabelWidth">
          <template>
            <editor v-model="formData.detail" height="1300px" :border="true" />
          </template>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import Editor from "../../components/Editor";

export default {
  components: {
    Editor, // 注册组件
  },
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      tableData: [],
      formData: {
        caseId: null,
        imgId: "",
        caseTitle: "",
        caseContent: "",
        detail: ""
      },

    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    handleSuccess(response, file, fileList) {
      // window.console.log(response, file, fileList);
      this.formData.imgId = response.data.fileId;
    },
    loadData() {
      this.loading = true;
      this.http
        .get("case/list")
        .then(response => {
          // window.console.log(response);
          this.tableData = response.data;
          this.loading = false;
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },
    openDialog() {
      // 清除数据
      this.formData.caseId = null;
      this.formData.imgId = "";
      this.formData.caseTitle = "";
      this.formData.caseContent = "";
      this.formData.detail = "";
      this.dialogFormVisible = true;
    },
    // 新增
    handleCreateOrModify() {
      // window.console.log(this.formData);
      let params = { ...this.formData }
      params.detail = this.reverseConvertEditorContent(params.detail)
      if (!this.formData.caseId) {
        // ID 无效时 视为新增
        this.loading = true;
        this.http
          .post("case/add", params)
          .then(() => {
            this.loading = false;
            this.$message({
              message: "创建成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.loadData();
          })
          .catch(e => {
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
      } else {
        this.loading = true;
        this.http
          .post("case/update", params)
          .then(() => {
            this.loading = false;
            this.$message({
              message: "修改成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.loadData();
          })
          .catch(e => {
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
      }
    },
    handleEdit(index, row) {
      // window.console.log(index, row);
      this.formData = { ...row };
      this.formData.content = this.convertEditorContent(this.formData.detail),
        this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      // window.console.log(index, row);
      this.$confirm("此操作将永久此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 已确认删除
          // 调接口删除
          this.loading = true;
          this.http
            .post(`case/delete`, null, { params: { caseId: row.caseId } })
            .then(response => {
              this.loading = false;
              this.$message({
                message: "删除成功！",
                type: "success"
              });
              this.loadData();
            })
            .catch(e => {
              this.loading = false;
              this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //时间格式化
    // dateFormat: function(row) {
    //   //row 表示一行数据, CreateTime 表示要格式化的字段名称
    //   let t = new Date(row.CreateTime);
    //   return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate();
    // }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>
